

const initialStateCity = {
  isLoading: false,

  citis: {},
  errors: null,
};
const cityReducers = (state = initialStateCity, action) => {
  switch (action.type) {
    case "cityList_req":
      return {
        ...state,
        isLoading: true,
      };
    case "cityList_success":
      return {
        ...state,
        isLoading: false,
        citis: action.payload,
      };
    case "cityList_failure":
      return {
        ...state,
        isLoading: false,
        errors: action.payload,
      };
    default:
      return state;
  }
};
export {  cityReducers };
